<section class="content" xmlns="">
  <div class="container-fluid">
    <div class="row">
      <div class="row mt-3">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="form-floating mb-3">
              <select class="form-select" (change)="selectValue($event)">
                <option value="">Select a Event Name</option>
                <option *ngFor="let event of this.eventDetails" [value]="event.eventId">{{event.eventName}} -
                  {{event.city}} -
                  {{formattedDate(event?.eventDate)}} {{ showThankYouMail(event) ? ',( Completed)' : '' }}</option>
                <!-- <option value="192">CIFA Surabhi - Indian Classical Dance Performance - Aug-3</option>
                <option value="180">CIFA Surabhi - Indian Classical Dance Performance - Sep-14</option> -->
              </select>
              <label for="formId1">Event Name</label>
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="form-floating mb-3">
              <input type="text" [(ngModel)]="searchText" class="form-control"
                placeholder="Search by Name, Email or Phone Number">
              <label>Search</label>
            </div>
          </div>
        </div>

        <div class="row align-items-center">

          <!-- Left Section -->
          <div class="col-12 col-md-4 mb-3 mb-md-0">
            <div class="d-flex flex-column gap-2">
              <h5 class="font-weight-bold mb-0">
                No of Booked : {{getListOfWorkshopDetails.length}}
              </h5>

              <h5 class="font-weight-bold mb-0">
                No of Participants Booked : {{participantBookingCount}}
              </h5>
            </div>

          </div>

          <div class="col-12 col-md-4 mb-3 mb-md-0">
            <div class="d-flex flex-column gap-2">

              <h5 class="font-weight-bold mb-0">
                Not Checked-in: {{ notCheckInCount }}
              </h5>

              <h5 class="font-weight-bold mb-0">
                Checked-in: {{ checkedInCount }}
              </h5>

            </div>
          </div>


          <!-- Right Section -->
          <div class="col-12 col-md-2 text-md-end">
            <button class="btn btn-primary w-100 w-md-auto" (click)="generateExcelSheet()">
             <i class="fa-solid fa-file-excel"></i> Generate Excel
            </button>
          </div>

          <div class="col-12 col-md-2 text-md-end">
            <button class="btn btn-success w-100 w-md-auto" (click)="SendReminderBulkWhatsapp()">
             <i class="fa-brands fa-whatsapp"></i> Send Bulk WhatsApp
            </button>
          </div>

        </div>



        <mat-card class="order-card">
          <div class="container-fluid">
            <div class="row">
              <mat-card-content>
                <div class="container-fluid mt-1">
                  <div class="table-responsive table-style table-bordered">
                    <table class="table table-gray table-head-fixed">
                      <thead class="h6">
                        <tr>
                          <th>S.No</th>
                          <th>Name</th>
                          <th>Sub Participants Name</th>
                          <th>City</th>
                          <th>Phone Number</th>
                          <th>Email ID</th>
                          <th>Booked Date</th>
                          <th>Ticket Number</th>
                          <th>Send Reminder Email</th>
                          <th>Send Reminder Whatsapp</th>
                          <th>Reminder Copy Message</th>
                          <!-- <th>Payment Status</th>
                          <th>Payments Details</th> -->
                        </tr>
                      </thead>
                      <tbody *ngIf="getListOfWorkshopDetails.length > 0; else noDataFound">
                        <tr class="text-center"
                          *ngFor="let work of getListOfWorkshopDetails | filter : searchText; let i = index;">
                          <td>{{ i + 1 }}</td>
                          <td>{{work?.name || "-"}}</td>
                          <td>
                            {{ getSubParticipantsNames(work?.audienceDetails) }}
                          </td>

                          <td>{{work?.district || "-"}}</td>
                          <td>{{work?.phoneNumber || "-"}}</td>
                          <td>{{work?.emailId || "-"}}</td>
                          <td>{{work?.createdAt | date : "MM/dd/yyyy"}}</td>
                          <td>
                            <a [href]="getTicketUrl(work?.audienceDetails[0]?.ticketSeq)" target="_blank"
                              class="text-primary fw-bold" data-bs-toggle="tooltip" title="Click to view ticket"
                              class="text-primary" style="cursor:pointer; text-decoration: underline;">

                              {{ work.audienceDetails[0]?.ticketSeq }}

                            </a>
                          </td>
                          <td>
                            <i class="fa-solid fa-paper-plane" style="font-size:28px" data-bs-toggle="tooltip"
                              data-bs-placement="top" title="Send Reminder Email"
                              (click)="sendReminderEmails(work?.workshopId)">
                            </i>
                          </td>
                          <td>
                            <i class="fa-brands fa-whatsapp text-green" style="font-size:28px" data-bs-toggle="tooltip"
                              data-bs-placement="top" title="Send Reminder Whatsapp"
                              (click)="sendReminderWhatsapp(work?.workshopId)">
                            </i>
                          </td>
                          <td>
                            <i class="fa-solid fa-keyboard text-gray" style="font-size:28px; cursor:pointer;"
                              title="Reminder Copy Message" (click)="openWhatsappModal(work)">
                            </i>
                          </td>
                        </tr>
                      </tbody>
                      <ng-template #noDataFound>
                        <tr>
                          <td colspan="11" class="text-center fw-bold">Data Not Found</td>
                        </tr>
                      </ng-template>
                    </table>
                  </div>
                </div>
              </mat-card-content>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</section>

<!-- WhatsApp Message Modal -->
<div class="modal fade" id="whatsappModal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered"> <!-- CENTER MODAL -->
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">WhatsApp Message</h5>
        <button class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
        <pre style="white-space: pre-wrap; font-size: 15px; line-height: 1.4;">
{{ whatsappMessage }}
        </pre>
      </div>

      <div class="modal-footer d-flex justify-content-between">

        <!-- Left Side: Copy Button -->
        <button class="btn btn-secondary" (click)="copyMessage()">
          <i class="fa-solid fa-copy me-1"></i> Copy Message
        </button>

        <!-- Right Side: Send WhatsApp Button -->
        <button class="btn btn-success" (click)="sendWhatsapp()">
          <i class="fa-brands fa-whatsapp me-1"></i>
          Send to {{ phoneNumber }}
        </button>
      </div>
    </div>
  </div>
</div>